import { getTranslation } from '@/hooks/useTranslation';

export function getPromptDetailRouteNavigationOptions(prompt, slug) {
  const fallback = slug
    ? String(slug).replace(/-/g, ' ').replace(/\b\w/g, ch => ch.toUpperCase())
    : (getTranslation('nav.routes.prompts.detail') || 'Prompt');
  const title = prompt?.name || fallback;
  return {
    title,
    headerTitle: title,
    headerBackVisible: true,
  };
}

export default getPromptDetailRouteNavigationOptions;
